<template>
  <div class="custom-text">
    <div :key="i" v-for="(el, i) in data">
      <hr v-if="i != 0" class="mb-3" />
      <vs-row>
        <vs-col vs-xs="12" vs-sm="6" vs-lg="6">
          <table>
            <tr>
              <td class="font-semibold">{{ $t('no_order') | capitalize }}:</td>
              <td><a @click.prevent="showDetails(el.id)" class="pointer">{{ el.no_order }}</a></td>
            </tr>
            <tr>
              <td class="font-semibold">{{ $t('trailer') | capitalize }}:</td>
              <td>{{ el.trailer_name }}</td>
            </tr>
            <tr>
              <td class="font-semibold">{{ $t('carrier') | capitalize }}:</td>
              <td>{{ el.transporter_name }}</td>
            </tr>
            <tr>
              <td class="font-semibold">{{ $t('driver') | capitalize }}:</td>
              <td>{{ el.driver }}</td>
            </tr>
            <tr>
              <td class="font-semibold">{{ $t('plates') | capitalize }}:</td>
              <td>{{ el.trailer_plates }}</td>
            </tr>
            <tr>
              <td class="font-semibold">SCAC:</td>
              <td>{{ el.trailer_SCAC }}</td>
            </tr>
            <tr>
              <td class="font-semibold">CAAT:</td>
              <td>{{ el.trailer_CAAT }}</td>
            </tr>
            <tr>
              <td class="font-semibold">{{ $tc('type') | capitalize }}:</td>
              <td>{{ el.trailer_type }}</td>
            </tr>
          </table>
        </vs-col>
        <vs-col vs-xs="12" vs-sm="6" vs-lg="6">
          <table>
            <tr>
              <td class="font-semibold">
                {{ $t('order_status') | capitalize }}:
              </td>
              <td>
                <vs-chip :color="el.status_color">
                  {{ el.status_name }}
                </vs-chip>
              </td>
            </tr>
            <tr>
              <td class="font-semibold">
                {{ $t('creation_date') | capitalize }}:
              </td>
              <td>{{ el.created_at }}</td>
            </tr>
            <tr>
              <td class="font-semibold">
                {{ $t('order_date') | capitalize }}:
              </td>
              <td>{{ el.order_date }}</td>
            </tr>
            <tr>
              <td class="font-semibold">
                {{ $t('confirmation_date') | capitalize }}:
              </td>
              <td>{{ el.warehouse_name }}</td>
            </tr>
          </table>
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
  },
  methods:{
    showDetails(id){
      console.log(id)
      let routeData = this.$router.resolve({
        name: 'load-order-details',
        params: {
          id: id
        }
      })
      window.open(routeData.href, '_blank');  
      // console.log(routeData);
    }
  }
}
</script>

<style>
.custom-text {
  font-size: 12px;
}
</style>